{
  "button-bar-for-continue-booking": {
    "button": {
      "cancel": "Annuler",
      "continue": "Continuer"
    },
    "text": {
      "continue-booking": "Votre réservation n'est pas encore terminée. Voulez-vous continuer ?"
    }
  }
}
